import ReactDOM from "react-dom";

export const CustomModalPortal = ({ children, isVisible = false }) => {
    if (!isVisible) return null;

    return ReactDOM.createPortal(
        <div className="fixed z-50 w-full h-full top-0 left-0 flex justify-center items-center">
            {children}
        </div>,
        document.getElementById("modal")
    );
};
